import socket from 'socket.io-client'

const IDE = window['IDE']

const config = require('../config')

let io
let disconnectByServer = false

export async function getSocket (type = 'message') {
  if (!io && !disconnectByServer) {
    let token = await IDE.getSetting('token')
    if (!token) {
      throw new Error('未登录')
    }
    try {
      io = socket.connect(config.messageServer, { query: 'type=' + type + '&token=' + token })
      io.on('disconnectByServer', () => {
        disconnectByServer = true
        IDE.$noty.warning('您的帐号在其它地点登陆，课堂连接中断。如果不是您的操作，请立即修改密码！', { timeout: 0, closeWith: [] })
      })
    } catch (e) {
      console.log(e)
    }
  }
  if (io) {
    return io
  } else if (disconnectByServer) {
    return { errMessage: '服务器拒绝连接' }
  }
}

let ojSocket

export async function getOjSocket () {
  if (!ojSocket) {
    let token = await IDE.getSetting('token')
    if (!token) {
      throw new Error('未登录')
    }
    try {
      ojSocket = socket.connect(config.ojServer, { query: 'token=' + token })
    } catch (e) {
      console.log(e)
    }
  }
  return ojSocket
}
